import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle, validatePermission } from '../../utilities/auth';
import {loader as escalationDetailsLoader} from '../../components/Escalation/components/EscalationForm';
import { QueryClient } from '@tanstack/react-query';

const UserListPage = withLazyLoading(
  () => import('../../pages/user-management/components/UserListPage')
);
const UserCreatePage = withLazyLoading(
  () => import('../../pages/user-management/components/UserCreatePage')
);
const UserEditPage = withLazyLoading(
  () => import('../../pages/user-management/components/UserEditPage')
);
const RoleListPage = withLazyLoading(
  () => import('../../pages/user-management/role/component/RoleListPage')
);
const RoleCreatePage = withLazyLoading(
  () => import('../../pages/user-management/role/component/RoleCreatePage')
);
const RoleEditPage = withLazyLoading(
  () => import('../../pages/user-management/role/component/RoleEditPage')
);
const PermissionList = withLazyLoading(
  () => import('../../pages/user-management/permissions/permissionList')
);
const GroupListPage = withLazyLoading(
  () => import('../../pages/userGroup/component/GroupListPage')
);
const GroupCreatePage = withLazyLoading(
  () => import('../../pages/userGroup/component/GroupCreatePage')
);
const GroupEditPage = withLazyLoading(
  () => import('../../pages/userGroup/component/GroupEditPage')
);
const DigitalPaaniTeam = withLazyLoading(
  () => import('../../pages/digitalPaaniTeam')
);
const EscalationList = withLazyLoading(
  () => import('../../components/Escalation/components/EscalationList')
);
const EscalationFormWrapper = withLazyLoading(
  () => import('../../components/Escalation/components/EscalationForm')
);

const CommunicationModule = withLazyLoading(
  () => import ('../../components/CommunicationModule/components/CommunicationModuleView')
)

const userRoutes =  (queryClient: QueryClient) => [
  {
    path: '/userGroupList',
    handle: createCrumbHandle('User Groups'),
    children: [
      {
        index: true,
        element: <GroupListPage />,
        loader: validatePermission('Group_View_R'),
      },
      {
        path: 'editUserGroup/:id',
        element: <GroupEditPage />,
        loader: validatePermission('Group_Configuration_WE'),
        handle: createCrumbHandle('Edit User Group'),
      },
      {
        path: 'createUserGroup',
        element: <GroupCreatePage />,
        loader: validatePermission('Group_Manage_A'),
        handle: createCrumbHandle('Create User Group'),
      },
    ]
  },
  {
    path: '/userList',
    handle: createCrumbHandle('Users'),
    children: [
      {
        index: true,
        element: <UserListPage />,
        loader: validatePermission('UserList_View_R'),
      },
      {
        path: 'editUser/:id',
        element: <UserEditPage />,
        loader: validatePermission('Add-EditUser_Configuration_AE'),
        handle: createCrumbHandle('Edit User'),
      },
      {
        path: 'createUser',
        element: <UserCreatePage />,
        loader: validatePermission('Add-EditUser_Configuration_AE'),
        handle: createCrumbHandle('Create User'),
      },
    ]
  },
  {
    path: '/rolelist',
    handle: createCrumbHandle('Roles'),
    children: [
      {
        index: true,
        element: <RoleListPage />,
        loader: validatePermission('RoleList_View_R'),
      },
      {
        path: 'editRole/:id',
        element: <RoleEditPage />,
        loader: validatePermission('GroupRole_Manage_WE'),
        handle: createCrumbHandle('Edit Role'),
      },
      {
        path: 'createrole',
        element: <RoleCreatePage />,
        loader: validatePermission('GroupRole_Manage_WE'),
        handle: createCrumbHandle('Create Role'),
      },
    ]
  },
  {
    path: '/escalation',
    handle: createCrumbHandle('Escalation'),
    children: [
      {
        index: true,
        element: <EscalationList />,
      },
      {
        path: 'create',
        element: <EscalationFormWrapper />,
        handle: createCrumbHandle('Create Escalation'),
      },
      {
        path: ':escalationId',
        element: <EscalationFormWrapper />,
        loader: escalationDetailsLoader(queryClient),
        handle: createCrumbHandle('Edit Escalation'),
      },
    ]
  },
  {
    path: '/permission',
    element: <PermissionList />,
    loader: validatePermission('PermissionsList_View_R'),
    handle: createCrumbHandle('Permissions'),
  },
  {
    path: '/digitalPaaniTeam',
    element: <DigitalPaaniTeam />,
    handle: createCrumbHandle('Digital Paani Team'),
  },
  {
    path: '/communication',
    element: <CommunicationModule />,
    handle: createCrumbHandle('Communication')
  }
];

export default userRoutes;
